import { lazy } from 'react';

export const listingModalComponentByType = {
  SHARE_LISTING: lazy(() =>
    import('./ShareListing/ShareListingModal').then((module) => ({
      default: module.ShareListingModal,
    })),
  ),
  FLAG_LISTING: lazy(() =>
    import('./FlagListing/FlagListingModalContainer').then((module) => ({
      default: module.FlagListingModalContainer,
    })),
  ),
  EMAIL_ALERT: lazy(() =>
    import('./EmailAlert/EmailAlertModalContainer').then((module) => ({
      default: module.EmailAlertModalContainer,
    })),
  ),
  ADMIN_REQUEST: lazy(() =>
    import('./AdminRequest/AdminRequestModal').then((module) => ({
      default: module.AdminRequestModal,
    })),
  ),
  MARK_APPLIED: lazy(() =>
    import('./MarkApplied/MarkAppliedModalContainer').then((module) => ({
      default: module.MarkAppliedModalContainer,
    })),
  ),
} as const satisfies Record<string, unknown>;
